<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
  <sequential-entrance fromTop> 
    <v-row>
    

 
      <v-col
        cols="12"
        sm="12"
        lg="6"
      >
      
        <base-material-card
          class="col-md-12"
          color="primary"
          inline
          title="Regional Map"
        >
          <v-card-text>
            <v-sheet>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193595.15831228695!2d-74.11976206978034!3d40.697663747508045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew+York%2C+NY!5e0!3m2!1sen!2sus!4v1566158235149!5m2!1sen!2sus"
                width="100%"
                height="450"
                frameborder="0"
                style="border:0"
                allowfullscreen
              />
            </v-sheet>
          </v-card-text>
        </base-material-card>
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="6"
      >
    <base-material-card
      color="success"
      icon="mdi-map-marker-radius"
      inline
      title="Safe Locations"
    >
      <v-data-table
        :headers="locationHeaders"
        :items="sites"
        :items-per-page="10"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td v-text="item.sitename"/>
            <td>
              <div
                class="black--text display-1"
                v-text="item.address"
              />         
            </td>
            <td v-text="item.city"/>
            <td align="center" v-text="item.zipcode" />
          </tr>
        </template>

      </v-data-table>
    </base-material-card>
      </v-col>

    </v-row>
           </sequential-entrance> 
  </v-container>
</template>

<script>
  export default {
    name: 'Locations',

    data () {
      return {
        sites: this.$store.getters.loadedSites,
        headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Product Name',
          value: 'name'
        },
        {
          text: 'Type',
          value: 'type'
        },
        {
          align: 'right',
          text: 'Qty',
          value: 'qty'
        },
        {
          align: 'right',
          text: 'Price',
          value: 'price'
        },
        {
          align: 'right',
          text: 'Amount',
          value: 'amount'
        }
        ],
        locationHeaders: [
          {
          sortable: true,
          text: 'Name'
          },
          {
          sortable: true,
          text: 'Street'
          },          
          {
          sortable: true,
          text: 'City'
          },          
          {
          align: 'center',
          sortable: true,
          text: 'Zipcode'
          }, 
        ],
        productHeaders: [
        {
          sortable: false,
          text: '',
          value: 'src'
        },
        {
          text: 'Product',
          value: 'name'
        },
        {
          text: 'Color',
          value: 'color'
        },
        {
          text: 'Size',
          value: 'size'
        },
        {
          align: 'right',
          text: 'Price',
          value: 'price'
        },
        {
          text: 'Qty',
          value: 'qty'
        },
        {
          align: 'right',
          text: 'Amount',
          value: 'amount'
        }
        ],
        selections: [
        {
          id: 1,
          name: 'Moleskine Agenda',
          type: 'Office',
          qty: 25,
          price: '€ 49',
          amount: '€ 1,225'
        },
        {
          id: 2,
          name: 'Stabilo Pen',
          type: 'Office',
          qty: 30,
          price: '€ 10',
          amount: '€ 300'
        },
        {
          id: 3,
          name: 'A4 Paper Pack',
          type: 'Office',
          qty: 30,
          price: '€ 10.99',
          amount: '€ 109'
        },
        {
          id: 4,
          name: 'Apple iPad',
          type: 'Meeting',
          qty: 10,
          price: '€ 499',
          amount: '€ 4,990'
        },
        {
          id: 5,
          name: 'Apple iPhone',
          type: 'Communication',
          qty: 10,
          price: '€ 599',
          amount: '€ 5,999'
        }
        ],        
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,
        tabs3: [
          {
            text: 'Locations',
            icon: 'mdi-map-marker'
          },
          {
            text: 'Wallets',
            icon: 'mdi-wallet-travel'
          },
          {
            text: 'Instant',
            icon: ' mdi-swap-horizontal'
          }
        ],
        tabs: 0,
        
        list: {
          0: false,
          1: false,
          2: false
        }
      }
    },
    created () {
      this.$store.dispatch('loadSiteConfigs')
    },
    computed: {
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      }
    },

    methods: {
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
